module.exports = __webpack_public_path__ + "static/media/pigpulse-mark.f2f356bf.png";